import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

import { customColors } from '../../theme/customColors';

export const linkBaseStyle = defineStyle({
  width: 'fit-content',
  fontWeight: 'regular',
  textDecoration: 'underline',
  textDecorationThickness: '1px',
  textUnderlineOffset: 5,
  '& > .orbit-external-link-icon': {
    ml: 1,
    verticalAlign: 'baseline',
    transform: 'translateY(3px)',
  },
  _hover: {
    textDecorationThickness: '1px',
    _disabled: {
      color: customColors.text.disabled,
    },
  },
  _active: {
    boxShadow: 'none',
  },
  _disabled: {
    color: customColors.text.disabled,
  },
  _focus: {
    boxShadow: 'unset',
  },
  _focusVisible: {
    outlineColor: customColors.border.focused,
    rounded: 'base',
    boxShadow: 'unset',
  },
});

export const LinkStyles = defineStyleConfig({
  baseStyle: linkBaseStyle,
});
